<template>
  <slot />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useVarietyPacksStore } from '@/stores'

const store = useVarietyPacksStore()

onMounted(async () => {
  const path = window.location.pathname.split('/')
  const handle = path[path.length - 1]
  await store.handleVarietyPackRoute(String(handle))
})
</script>
